
import { useState } from 'react';
import { UnitSystem } from '@/utils/unitConversion/types';
import { toast } from 'sonner';
import { useLocalStorage } from '@/hooks/useLocalStorage';

const LOCAL_STORAGE_KEY = 'preferred-units';

export const useUnitPreferences = () => {
  // Use the useLocalStorage hook for persistent storage with cross-tab synchronization
  const [preferredUnits, setStoredPreferredUnits] = useLocalStorage<UnitSystem>(
    LOCAL_STORAGE_KEY, 
    'metric'
  );
  
  const [loading, setLoading] = useState(false);

  // Wrapper function to set preferences and show notification
  const handleSetPreferredUnits = (value: UnitSystem) => {
    setStoredPreferredUnits(value);
    toast.info(`Unit preference updated to ${value}`);
  };

  return {
    preferredUnits,
    setPreferredUnits: handleSetPreferredUnits,
    loading
  };
};
